import React from "react"
import getSrc from "./get-src"
import { useImageContext } from "./image-context"

const Image = ({ data }) => {
  const { alt, borderRadius, href, src, optimize, triggerId } = data
  const { width } = useImageContext()

  const Tag = href ? "a" : "div"

  const linkProps = href
    ? {
        href,
        target: "_blank",
        rel: "noopener noreferrer",
        "trigger-id": triggerId
      }
    : {}

  return (
    <Tag
      style={{
        display: "block",
        ...(width && { maxWidth: `${width}px` })
      }}
      {...linkProps}
    >
      <img
        src={getSrc(src, { optimize })}
        alt={alt}
        // 800 is the fallback for the `width` attribute because Outlook does not
        // support percentage widths for images. Other clients/browsers will respect
        // the value we pass for `width` in the `style` attribute.
        width={Math.min(width || 800, 800)}
        style={{
          width: width ? `${width}px` : "100%",
          maxWidth: "100%",
          borderRadius: `${borderRadius}px`
        }}
      />
    </Tag>
  )
}

export default Image
